import { Pipe, PipeTransform } from '@angular/core';
import { DeliveryAddress } from '../models';

@Pipe({
    name: 'formattedAddress',
    standalone: true,
    pure: true
})
export class FormattedAddressPipe implements PipeTransform {
    transform(deliveryAddress: DeliveryAddress | null | undefined): string {
        if (!deliveryAddress) {
            return '';
        }
        const { address, ward_name, district_name, city_name } = deliveryAddress;
        return [address, ward_name, district_name, city_name].filter(Boolean).join(', ');
    }
}
